<template>
  <div>
    <CommonHeader :page="'Gestion des permissions pour ' + client.name" />
    <GStockLoader :loading="loading" />
    <b-container fluid>
      <b-row
        class="my-1"
        style="margin-top: 25px !important"
        v-for="(permission, index) in form"
        :key="index"
      >
        <b-col sm="3">
          <div style="font-size: 20px; font-weight: bold">
            {{ permission.permission }}
          </div>
        </b-col>
        <b-col sm="9">
          <b-form-checkbox
            v-model="permission.active"
            name="check-button"
            switch
            @change="managePermissions(permission.permissionid)"
          />
        </b-col>
      </b-row>
      <!-- <div>
        <b-button size="lg" variant="primary" @click="managePermissions"
          >Valider</b-button
        >
      </div> -->
    </b-container>
  </div>
</template>
<script>
import { get, post } from "@/mixins/api";
import GStockLoader from "@/components/Loader";
import CommonHeader from "@/components/CommonHeader";
export default {
  components: {
    GStockLoader,
    CommonHeader,
  },
  data() {
    return {
      loading: false,
      user: "",
      permissions: [],
      userpermissions: [],
      ready: 0,
      form: [],
      client: {},
    };
  },
  watch: {
    ready: {
      handler: function (newVal) {
        if (newVal == 2) {
          this.form = [];
          this.permissions.forEach((element) => {
            this.form.push({
              permission: element.name,
              permissionid: element.id,
              active: this.userpermissions.some(
                (x) => x.permissionid == element.id && x.userid == this.user
              ),
            });
            this.loading = false;
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    managePermissions(permissionid) {
      post("userpermissions", {
        userid: this.user,
        permissionid,
        action: this.form.find((x) => x.permissionid == permissionid).active
          ? 0
          : 1,
      });
    },
  },
  mounted() {
    this.user = this.$route.params.id;
    this.loading = true;
    get("permissions").then((res) => {
      this.permissions = res.data.data;
      this.ready++;
    });
    get("userpermissions").then((res) => {
      this.userpermissions = res.data.data;
      this.ready++;
    });
    get("user/" + this.user).then((res) => {
      this.client = res.data.data;
    });
  },
};
</script>
<style>
</style>